import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../../components/Dashboard/DashboardPage';
import YoutubeDashboard from '../../../components/Dashboard/Video/YoutubeDashboard';
import withApollo from '../../../lib/withApollo';

const VideoPage = () => {
  const router = useRouter();

  const { open } = router.query;

  return (
    <>
      <DashboardPage open={open} label="video" content={<YoutubeDashboard />} />
    </>
  );
};

export default withApollo(VideoPage);
